"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashUwa = hashUwa;
exports.setupUWA = setupUWA;
exports.getCurrentUwaHashedAccountId = getCurrentUwaHashedAccountId;
exports.getPrimaryUwaHashedAccountId = getPrimaryUwaHashedAccountId;
// Used to obfuscate user id hash, we know that this is not secure, but it is enough for our use case.
const UWA_SUFFIX = "uHgjT8UaFGrpCRJ";
const UWA_PREFIX = "UwA";
const PRIMARY_COOKIE_NAME = "__hmpuhai"; // PrimaryUwaHashedAccountId, First id generated for the user
const CURRENT_COOKIE_NAME = "__hmcuhai"; // CurrentUwaHashedAccountId, // Current id generated for the user, will be updated on every login
const LIFETIME = 10 * 60 * 60 * 24 * 365;
async function hashUwa(id) {
    const encoder = new TextEncoder();
    const data = encoder.encode(`${UWA_PREFIX}/${id}/${UWA_SUFFIX}`);
    const hashBuffer = await window.crypto.subtle.digest("SHA-1", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}
function getCookie(name) {
    let result = null;
    document.cookie.split(";").forEach((c) => {
        const [key, value] = c.trim().split("=");
        if (key === name) {
            result = value;
        }
    });
    return result;
}
function setCookie(domain, name, value, overwrite = false) {
    const ts = new Date();
    ts.setSeconds(ts.getSeconds() + LIFETIME);
    if (!overwrite && getCookie(name) !== null) {
        return;
    }
    document.cookie = `${name}=${value}; expires=${ts.toUTCString()}; domain=${domain}; path=/`;
}
function setupUWA(domain, accountId) {
    return new Promise((resolve) => {
        hashUwa(accountId).then((hashedId) => {
            if (!hashedId) {
                return;
            }
            setCookie(domain, PRIMARY_COOKIE_NAME, hashedId);
            setCookie(domain, CURRENT_COOKIE_NAME, hashedId, true);
            resolve();
        });
    });
}
function getCurrentUwaHashedAccountId() {
    return getCookie(CURRENT_COOKIE_NAME);
}
function getPrimaryUwaHashedAccountId() {
    return getCookie(PRIMARY_COOKIE_NAME);
}
//# sourceMappingURL=index.js.map